import { createStore } from 'redux';
import birdApp from './action';
export const store = createStore(birdApp);
      